import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

const DEFAULT_TTL_SECONDS = 60 * 60;

/**
 * Short-lived signed URL for one object in a private bucket (job-signatures,
 * job-photos). Null path → disabled. Storage RLS decides who may sign.
 */
export function useSignedStorageUrl(bucket: string, path: string | null | undefined, ttlSeconds = DEFAULT_TTL_SECONDS) {
  return useQuery({
    queryKey: ['signed-url', bucket, path ?? null],
    queryFn: async (): Promise<string | null> => {
      if (!path) return null;
      const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, ttlSeconds);
      if (error) throw error;
      return data?.signedUrl ?? null;
    },
    enabled: !!path,
    staleTime: (ttlSeconds / 2) * 1000,
  });
}
